import { render, staticRenderFns } from "./PopupMailjetSettings.vue?vue&type=template&id=2c37f183&"
import script from "./PopupMailjetSettings.vue?vue&type=script&lang=js&"
export * from "./PopupMailjetSettings.vue?vue&type=script&lang=js&"
import style0 from "./PopupMailjetSettings.vue?vue&type=style&index=0&id=2c37f183&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports